<template>
  <!-- 金額輸入列 -->
  <div class="colu-12">
    <label
      class="colu-12 for-label"
      :for="inputId"
    >
      <template v-if="isCryptoExchange">
        {{ $t('Bao.please_enter_purchase_amount') }}
      </template>
      <template v-else>
        {{ $t('Bao.please_enter_withdrawal_amount') }}
      </template>
    </label>

    <div class="row-frame">
      <div :class="isPC ? 'colu colu-9' : 'colu colu-8'">
        <!-- readonly 到使用者聚焦才解除：Chrome 會無視 autocomplete="off" 把此欄誤認為帳號欄自動填入，
             但不會填 readonly 欄位；data-* 為各家密碼管理員（LastPass/1Password/Bitwarden）的忽略註記 -->
        <input
          :id="inputId"
          :value="amount"
          :placeholder="$t('Bao.input_withdrawal_amount')"
          class="for-input inpType"
          :name="inputId"
          autocomplete="off"
          inputmode="numeric"
          data-lpignore="true"
          data-1p-ignore
          data-bwignore
          data-form-type="other"
          type="text"
          :readonly="preventAutofill"
          @focus="preventAutofill = false"
          @input="onInput"
          @keypress="onlyNumbers"
        >
      </div>
      <div :class="isPC ? 'colu colu-3' : 'colu colu-4'">
        <button
          class="btn button-style btn-creat"
          @click.prevent="$emit('set-all')"
        >
          {{ $t('Bao.withdrawal_all') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { detectMob } from '@/utils/tool'

export default {
  name: 'AmountInput',
  props: {
    amount: {
      type: [String, Number],
      default: ''
    },
    isCryptoExchange: {
      type: Boolean,
      default: false
    },
    /** 供 label[for] 綁定，避免 MB/PC 同頁面 id 重複 */
    inputId: {
      type: String,
      default: 'withdraw-amount-input'
    }
  },
  data() {
    return {
      // 防瀏覽器自動填入：初始 readonly，聚焦後解除
      preventAutofill: true
    }
  },
  computed: {
    isPC() {
      return !detectMob()
    }
  },
  methods: {
    onInput(event) {
      this.$emit('update:amount', event.target.value)
      this.$emit('input', event)
    },
    onlyNumbers(event) {
      if (
        !/[0-9]/.test(event.key) &&
        !['Backspace', 'Delete', 'Tab', 'Enter'].includes(event.key)
      ) {
        event.preventDefault()
      }
    }
  }
}
</script>
